import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicSpaceman({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 175 175"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <path
          d="M36.72 61.41a36.72 36.72 0 0035.04-47.7C65.13-7.44 56.99 2.24 36.72 2.24c-20.28 0-27.54-9.27-34.52 9.9a36.72 36.72 0 0034.51 49.28z"
          id="pic-spaceman_svg__e"
        />
        <path
          d="M36.72 61.41a36.72 36.72 0 0035.04-47.7C65.13-7.44 56.99 2.24 36.72 2.24c-20.28 0-27.54-9.27-34.52 9.9a36.72 36.72 0 0034.51 49.28z"
          id="pic-spaceman_svg__g"
        />
        <path
          d="M152.56 146.14c3.71 2.44 6.96 2.44 9.73 0a31.26 31.26 0 006.96-8.92c1.71-4.29 3.11-7.16 4.2-8.6 1.62-2.17-3.34-7.8-6-7.8s-10.59 1.1-13.46 4.45c-1.92 2.23-2.97 5.27-3.15 9.13-1.46 2.85-2.19 5.07-2.19 6.67 0 1.6 1.3 3.28 3.91 5.07z"
          id="pic-spaceman_svg__j"
        />
        <linearGradient x1="3.91%" y1="61.68%" x2="104.71%" y2="38.32%" id="pic-spaceman_svg__c">
          <stop stopColor="#FFF" stopOpacity={0.8} offset="0%" />
          <stop stopColor="#FFF" stopOpacity={0} offset="100%" />
        </linearGradient>
        <linearGradient x1="3.91%" y1="61.68%" x2="104.71%" y2="38.32%" id="pic-spaceman_svg__d">
          <stop stopColor="#FFF" stopOpacity={0.8} offset="0%" />
          <stop stopColor="#FFF" stopOpacity={0} offset="100%" />
        </linearGradient>
        <filter
          x="-4%"
          y="-3.7%"
          width="111.9%"
          height="114.7%"
          filterUnits="objectBoundingBox"
          id="pic-spaceman_svg__i"
        >
          <feOffset dx={1} dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.180392157 0 0 0 0 0.192156863 0 0 0 0 0.337254902 0 0 0 0.15 0"
            in="shadowOffsetOuter1"
          />
        </filter>
        <filter
          x="-16%"
          y="-14.8%"
          width="132%"
          height="129.6%"
          filterUnits="objectBoundingBox"
          id="pic-spaceman_svg__k"
        >
          <feOffset dx={-1} dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.180392157 0 0 0 0 0.192156863 0 0 0 0 0.337254902 0 0 0 0.15 0"
            in="shadowOffsetOuter1"
            result="shadowMatrixOuter1"
          />
          <feMerge>
            <feMergeNode in="shadowMatrixOuter1" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <circle id="pic-spaceman_svg__a" cx={87.22} cy={87.22} r={87.22} />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(.13 .35)">
          <mask id="pic-spaceman_svg__b" fill="#fff">
            <use xlinkHref="#pic-spaceman_svg__a" />
          </mask>
          <use fill="#504F4F" xlinkHref="#pic-spaceman_svg__a" />
          <path
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            d="M54.53 143.23l-31.82 9.85 12.87 26.55 121.08 11.98 2.81-41.65-35.71-6.73z"
          />
          <rect
            fill="#E3E8E8"
            mask="url(#pic-spaceman_svg__b)"
            x={58.37}
            y={161.55}
            width={58.37}
            height={34.62}
            rx={5.43}
          />
          <circle
            strokeOpacity={0.15}
            stroke="#2E3156"
            strokeWidth={2.04}
            mask="url(#pic-spaceman_svg__b)"
            cx={87.22}
            cy={87.22}
            r={86.2}
          />
          <circle
            fillOpacity={0.6}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={70.47}
            cy={28.16}
            r={1.36}
          />
          <circle
            fillOpacity={0.6}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={130.88}
            cy={52.59}
            r={1.36}
          />
          <circle
            fillOpacity={0.6}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={12.09}
            cy={108.25}
            r={1.36}
          />
          <circle
            fillOpacity={0.6}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={149.2}
            cy={119.79}
            r={1.36}
          />
          <circle
            fillOpacity={0.6}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={13.79}
            cy={73.97}
            r={1.02}
          />
          <circle
            fillOpacity={0.6}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={144.11}
            cy={139.14}
            r={1.02}
          />
          <circle
            fillOpacity={0.3}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={151.92}
            cy={59.38}
            r={1.36}
          />
          <circle
            fillOpacity={0.3}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={129.52}
            cy={28.84}
            r={1.36}
          />
          <circle
            fillOpacity={0.3}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={100.33}
            cy={44.45}
            r={1.36}
          />
          <circle
            fillOpacity={0.2}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={89.47}
            cy={20.01}
            r={1}
          />
          <circle
            fillOpacity={0.2}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={14.13}
            cy={54.63}
            r={1}
          />
          <circle
            fillOpacity={0.2}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={39.24}
            cy={118.43}
            r={1}
          />
          <circle
            fillOpacity={0.2}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={145.13}
            cy={43.77}
            r={1}
          />
          <circle
            fillOpacity={0.2}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={168.89}
            cy={95.36}
            r={1}
          />
          <circle
            fillOpacity={0.3}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={33.13}
            cy={77.71}
            r={1.36}
          />
          <circle
            fillOpacity={0.3}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={31.1}
            cy={113}
            r={1.36}
          />
          <circle
            fillOpacity={0.3}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={41.28}
            cy={32.23}
            r={2.72}
          />
          <circle
            fillOpacity={0.8}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={118.66}
            cy={39.7}
            r={1}
          />
          <circle
            fillOpacity={0.8}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={145.81}
            cy={89.25}
            r={1}
          />
          <circle
            fillOpacity={0.8}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={157.35}
            cy={112.33}
            r={1}
          />
          <circle
            fillOpacity={0.8}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={38.56}
            cy={59.38}
            r={1}
          />
          <circle
            fillOpacity={0.8}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={96.26}
            cy={11.19}
            r={1}
          />
          <circle
            fillOpacity={0.8}
            fill="#FFF"
            mask="url(#pic-spaceman_svg__b)"
            cx={41.96}
            cy={141.51}
            r={1}
          />
          <path
            d="M94.22 30.2L55.51 49.07a1.02 1.02 0 11-.66-1.18l39.37-17.7z"
            fill="url(#pic-spaceman_svg__c)"
            opacity={0.4}
            mask="url(#pic-spaceman_svg__b)"
          />
          <path
            d="M158.03 125.9l-25.81 12.6a.68.68 0 11-.44-.8l26.25-11.8z"
            fill="url(#pic-spaceman_svg__d)"
            opacity={0.2}
            mask="url(#pic-spaceman_svg__b)"
          />
        </g>
        <path
          d="M56.9 137.11h61.3c1.63.2 2.8 1.33 3.52 3.35 1.08 3.04.2 5.08-2.16 6.4-18.58 10.44-46.1 10.44-62.66.56-1.47-.88-4.63-2.3-3.83-5.9.54-2.4 1.81-3.86 3.83-4.4z"
          fill="#E3E8E8"
        />
        <path d="M56.34 122.86h62.45v14.37c-19.4 13.64-37.5 16.2-62.45 0v-14.37z" fill="#CCC" />
        <g transform="translate(40.05 55.66)">
          <circle fill="#FFF" cx={47.59} cy={42.83} r={42.83} />
          <g transform="translate(12.88 20.16)">
            <mask id="pic-spaceman_svg__f" fill="#fff">
              <use xlinkHref="#pic-spaceman_svg__e" />
            </mask>
            <use fill="#374681" xlinkHref="#pic-spaceman_svg__e" />
            <circle
              fill="#56A"
              opacity={0.5}
              mask="url(#pic-spaceman_svg__f)"
              cx={18}
              cy={18}
              r={24.48}
            />
            <mask id="pic-spaceman_svg__h" fill="#fff">
              <use xlinkHref="#pic-spaceman_svg__g" />
            </mask>
            <path
              strokeOpacity={0.1}
              stroke="#000"
              strokeWidth={2.04}
              d="M36.72 60.4A35.7 35.7 0 0070.79 14c-2.34-7.46-4.85-11.06-8.2-12.33-2.67-1.02-4.14-.92-13.12.46a79.09 79.09 0 01-12.75 1.12 79.2 79.2 0 01-12.94-1.13c-8.84-1.38-10-1.47-12.55-.6-3.19 1.1-5.63 4.27-8.07 10.96A35.7 35.7 0 0036.71 60.4z"
            />
            <circle fill="#FFF" mask="url(#pic-spaceman_svg__h)" cx={13.68} cy={12.24} r={4.32} />
            <circle fill="#FFF" mask="url(#pic-spaceman_svg__h)" cx={15.84} cy={21.6} r={2.16} />
          </g>
          <path
            d="M2.33 35.1l5.93-2.7v25.9l-5.69-2.06a3.4 3.4 0 01-2.23-3.2V38.19a3.4 3.4 0 011.99-3.09zm91.17 0l-5.94-2.7v25.9l5.69-2.06a3.4 3.4 0 002.23-3.2V38.19a3.4 3.4 0 00-1.99-3.09z"
            fill="#FFF"
          />
        </g>
        <use fill="#000" filter="url(#pic-spaceman_svg__i)" xlinkHref="#pic-spaceman_svg__j" />
        <use fill="#FFF" xlinkHref="#pic-spaceman_svg__j" />
        <g filter="url(#pic-spaceman_svg__k)" transform="translate(7.47 124.9)">
          <path
            d="M16.7 24.23c1.54 2.04 3.12 2.9 4.75 2.58 2.44-.47 2.93-3.18.5-6.02-1.64-1.88-2.8-2.28-3.5-1.17l-1.75 4.6z"
            fill="#F5F7F7"
          />
          <path
            d="M24.44 15.12c0-4.9-2.3-8.94-5.75-12.12C16.39.9 12.19-.1 6.09.01a11.08 11.08 0 00-5.1 6.31c-1.23 3.98-1.4 5.75 0 7.28 1.4 1.52 7.17 4.89 8.53 6.37 1.36 1.48 4.7 6.7 9.17 4.7 4.47-2.01 5.75-4.65 5.75-9.55z"
            fill="#FFF"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicSpaceman.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicSpaceman.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPicSpaceman svgRef={ref} {...props} />);
export default ForwardRef;
